import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/system-files/new/loading';

export const Route = createFileRoute('/_private/settings/system-files/new')({
  component: Loading,
});
